<!-- <div class="mandatory-alert">
  <div class="alert-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-alert w-5 h-5 text-white"><circle cx="12" cy="12" r="10"></circle><line x1="12" x2="12" y1="8" y2="12"></line><line x1="12" x2="12.01" y1="16" y2="16"></line></svg>
  </div>

  <div class="alert-content">
    <div class="alert-title">
      Mandatory Rule Triggered: Auto-Fail
    </div>

    <div class="alert-message">
      Resident must not have severe alcohol (ETOH) dependence with withdrawal symptoms.
    </div>

    <div class="alert-note">
      This mandatory rule overrides the weighted score and forces a Fail recommendation.
    </div>
  </div>
</div> -->



<div class="card">
  <div class="card-header">
    <div>
      <h3>AI Weighted Score</h3>
      <p class="subtext">Calculated from {{ThresholdList.length}} questions (excluding Follow-Ups)</p>
    </div>

    <span *ngIf="Recommendation=='Fail'" class="badge fail">Recommendation<br>{{Recommendation}}</span>
    <span *ngIf="Recommendation=='Pass'" class="badge pass">Recommendation<br>{{Recommendation}}</span>
    <span *ngIf="Recommendation=='Follow Up'" class="badge followup">Recommendation<br>{{Recommendation}}</span>


  </div>

  <div class="progress-wrapper">
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="(overAllContribution / thresholdValue)">
      </div>


      <!-- center text -->
      <span class="score-text">
        {{ overAllContribution }} / {{ thresholdValue }}
      </span>
    </div>
  </div>



</div>

<br>
<!-- Rule Card -->
<div class="rule-card fail" *ngFor="let item of ThresholdList;let i = index">

  <!-- Header -->
  <div class="rule-header">
    <div class="left">
      <div class="status-dropdown" [ngClass]="item.statusName">
        <select [(ngModel)]="item.statusName" (change)="onStatusChange($event.target.value,item)">
          <option value="Pass">Pass</option>
          <option value="Fail">Fail</option>
          <option value="FollowUp">Follow Up</option>
        </select>
      </div>


      <span *ngIf="item.mandatoryRule == true && item.isMandatoryPass == true" class="mandatory-pillpass">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-shield w-3 h-3">
          <path
            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
          </path>
        </svg>
        Mandatory Pass
      </span>

      <span *ngIf="item.mandatoryRule == true && item.isMandatoryPass == false" class="mandatory-pillfail">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-shield w-3 h-3">
          <path
            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
          </path>
        </svg>
        Mandatory Fail
      </span>

      <button *ngIf="item.isFollowUpFlag" mat-stroked-button
        [matMenuTriggerFor]="starMenu" class="icon-button">

        <mat-icon class="followups-icon"
          [ngClass]="{
            'accept-flag': item.followUpFlagResult == 1,
            'reject-flag': item.followUpFlagResult == 3,
            'review-flag': item.followUpFlagResult == 2
          }">
          flag
        </mat-icon>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #starMenu="matMenu" panelClass="no-border-menu">
        <button mat-menu-item (click)="onFollowUpChange(item, 'Accept')">
          <span>Accept</span>
        </button>

        <button mat-menu-item (click)="onFollowUpChange(item, 'Reject')">
          <span>Reject</span>
        </button>

        <button mat-menu-item (click)="onFollowUpChange(item, 'Review')">
          <span>Review</span>
        </button>
      </mat-menu>


      <span class="weight">Weight: {{item.contribution}}/{{item.weight}}</span>
    </div>

    <div class="action-buttons">

      <button mat-icon-button *ngIf="item.memoryCard" class="save-btn" matTooltip="View Memory card detail"
        (click)="viewMemoryCard(item)">
        <mat-icon>sd_card</mat-icon>
      </button>

      <button mat-icon-button class="edit-btn" matTooltip="Edit answer" (click)="openaiAnswer(updateanswer, item)">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="rule-body">
    <div class="question">
      <span class="q-label">Q:</span>
      <span class="q-text">{{ item.questionTitle }}</span>
    </div>

    <div class="answer">
      <span class="q-label">A: </span>
      <span class="q-text">{{item.aiResultName}}, {{ item.aiAnswer }}</span>
      <!-- <p style="font-weight: 400;">A:</p> {{item.aiAnswer}} -->
    </div>

    <!-- Toggle -->
    <div class="actions">
      <a (click)="toggleEvidence(i)">
        {{ selectedEvidenceIndex === i
        ? 'Hide AI Evidence & Reasoning'
        : 'View AI Evidence & Reasoning' }}
      </a>
      <!-- <a (click)="toggleEvidence()">
        {{ showEvidence ? 'Hide AI Evidence & Reasoning' : 'View AI Evidence & Reasoning' }}
      </a> -->
    </div>

    <!-- EXPANDABLE SECTION -->
    <div class="evidence-section" *ngIf="selectedEvidenceIndex === i">

      <!-- AI Analysis -->
      <div class="analysis-box">
        <div class="analysis-title">AI Analysis:</div>
        <p>
          {{item.aiAnalysis}}
          <!-- The AI identified multiple indicators in the medical records suggesting alcohol dependence.
          The resident is suspected of excessive alcohol use and is currently on the CIWA
          (Clinical Institute Withdrawal Assessment for Alcohol) protocol, which is specifically
          used for managing alcohol withdrawal symptoms. This protocol is only implemented
          when there are signs of withdrawal, indicating active alcohol dependence requiring
          medical supervision. -->
        </p>
      </div>

      <!-- <textarea class="notes-input"
        placeholder="Enter follow-up notes or required actions..."
        [(ngModel)]="followUpNotes">
      </textarea>

      
      <div class="note-actions">
        <button class="btn-primary">Save Note</button>
        <button class="btn-secondary">Cancel</button>
      </div> -->

    </div>
  </div>
</div>

<ng-template #updateanswer>
  <form [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>question_answer</mat-icon>
      </span>
      Update Answer

      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">

      <div class="allheaders">

        <mat-form-field class="example-half-width">
          <mat-label>AI Answer</mat-label>
          <textarea style="height: 120px;" matInput placeholder="add answer" rows="5" cols="40"
            formControlName="aiAnswer">
         </textarea>
        </mat-form-field>


      </div>

    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <div class="">
        <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty"
          (click)="updateaiAnswer(formDialog.value)">
          Update
        </button>
      </div>
    </mat-dialog-actions>
  </form>
</ng-template>